import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import CalcService from "src/services/calc-service"
import dayjs from "dayjs"
import { DATE_TIME_FORMAT_SHOW } from "src/utils/constants"
import ParameterTable from "src/components/table/parameter-table"
import { formatDateUtc } from "src/utils/date-format"

const ParameterFaixaDurationTable = (props) => {
    const calcService = new CalcService()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        calcService.loadEndpoint(props.endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            'DurationMin': 0,
            'DurationMax': 0,
            'TipoDado': "N/A",
            'IndiceFaixa': 0,
            'VerticeDC': 0,
            'VerticeDU': 0,
            'FaixaDuration': "0 a 0",
        }

        props.loading(true)
        return calcService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, DurationMin, DurationMax, TipoDado, IndiceFaixa, FaixaDuration, VerticeDU, VerticeDC } = newRow

        const body = {
            'DurationMin': DurationMin,
            'DurationMax': DurationMax,
            'TipoDado': TipoDado,
            'IndiceFaixa': IndiceFaixa,
            'FaixaDuration': FaixaDuration,
            'VerticeDU': VerticeDU,
            'VerticeDC': VerticeDC,
        }

        props.loading(true)
        return calcService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return calcService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
        },
        {
            field: 'DurationMin',
            headerName: 'DurationMin',
            flex: 1,
            editable: true
        },
        {
            field: 'DurationMax',
            headerName: 'DurationMax',
            flex: 1,
            editable: true
        },
        {
            field: 'TipoDado',
            headerName: 'TipoDado',
            flex: 1,
            editable: true
        },
        {
            field: 'IndiceFaixa',
            headerName: 'IndiceFaixa',
            flex: 1,
            editable: true
        },
        {
            field: 'FaixaDuration',
            headerName: 'FaixaDuration',
            flex: true,
            editable: true
        },
        {
            field: 'VerticeDU',
            headerName: 'VerticeDU',
            flex: true,
            editable: true
        },
        {
            field: 'VerticeDC',
            headerName: 'VerticeDC',
            flex: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                loadData={loadData} />
        </div>
    )
}

ParameterFaixaDurationTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterFaixaDurationTable
